'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../../node_modules/tslib/tslib.es6.js');
var React = require('react');
var DesktopNavbar = require('./DesktopNavbar/DesktopNavbar.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var NavbarContext = React.createContext({});
var Navbar = function (props) {
    var _a = props.isAuthenticated, isAuthenticated = _a === void 0 ? false : _a, authenticatedMenu = props.authenticatedMenu, menu = props.menu, activeMenu = props.activeMenu;
    var finalMenu = menu;
    var _b = React.useState(false), isDesktop = _b[0], setIsDesktop = _b[1];
    if (isAuthenticated && authenticatedMenu) {
        if (!isDesktop) {
            finalMenu = authenticatedMenu.concat(menu);
        }
        else {
            finalMenu = menu.concat(authenticatedMenu);
        }
    }
    var activeLinks = getActiveMenuLinks(finalMenu, activeMenu);
    React.useEffect(function () {
        var resizeHandler = function () {
            var mobileBreakpoint = window.matchMedia('(max-width: 1199px)');
            var desktopBreakpoint = window.matchMedia('(min-width: 1200px)');
            if (mobileBreakpoint.matches) {
                setIsDesktop(false);
            }
            else if (desktopBreakpoint.matches) {
                setIsDesktop(true);
            }
        };
        resizeHandler();
        window.addEventListener('resize', resizeHandler);
        return function () {
            window.removeEventListener('resize', resizeHandler);
        };
    }, []);
    return (React__default['default'].createElement(NavbarContext.Provider, { value: tslib_es6.__assign(tslib_es6.__assign({}, props), { finalMenu: finalMenu,
            activeLinks: activeLinks }) },
        React__default['default'].createElement(DesktopNavbar.DesktopNavbar, { isDesktop: isDesktop })));
};
function getActiveMenuLinks(menu, activeMenuLink) {
    var activeMenus = [];
    activeMenuLink &&
        menu.forEach(function (menu) {
            if (menu.link === activeMenuLink) {
                activeMenus.push(menu.link);
                return;
            }
            if (menu.childItems && Array.isArray(menu.childItems)) {
                var subMenu = getActiveMenuLinks(menu.childItems, activeMenuLink);
                if (subMenu.length) {
                    activeMenus = activeMenus.concat(subMenu);
                    activeMenus.push(menu.link);
                    return;
                }
            }
        });
    return activeMenus;
}
var useNavbarContext = function () { return React.useContext(NavbarContext); };

exports.Navbar = Navbar;
exports.useNavbarContext = useNavbarContext;
//# sourceMappingURL=Navbar.js.map
